var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"custom-alert",attrs:{"color":_vm.color,"icon":_vm.icon,"dense":"","outlined":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }